import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './services.css'

const Services = (props) => {
  return (
    <div className="services-container1">
      <Helmet>
        <title>Services - Panda Demolition &amp; Disposal</title>
        <meta
          property="og:title"
          content="Services - Panda Demolition & Disposal"
        />
        <link
          rel="canonical"
          href="https://www.pandademolition.com/services"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="services-hero-section">
        <div className="hero-video-wrapper">
          <video
            src="https://videos.pexels.com/video-files/5594431/5594431-hd_1280_720_25fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/5594431/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
          ></video>
          <div className="hero-scrim"></div>
        </div>
        <div className="services-hero-content-container">
          <div className="services-hero-text-block">
            <h1 className="services-hero-title hero-title">
              Precision Demolition &amp; Total Disposal Solutions
            </h1>
            <p className="hero-subtitle services-hero-subtitle">
              From residential tear-downs to industrial site clearing, Panda
              Demolition delivers safe, efficient, and eco-conscious removal
              services across the region.
            </p>
            <div className="hero-actions">
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
                <div className="btn-primary btn-lg btn">
                  <span>Book a Dumpster</span>
                </div>
              </button>
              <a href="/rfq-portal">
                <div className="btn-lg btn-outline btn">
                  <span>Submit Project RFQ</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="demo-options-section">
        <div className="services-section-container">
          <div className="services-section-header">
            <h2 className="services-section-title section-title">
              Demolition Expertise
            </h2>
            <p className="section-content">
              Specialized structural removal tailored to your project scope and
              safety requirements.
            </p>
          </div>
          <div className="tabs-wrapper">
            <div role="tablist" className="tabs-nav">
              <button
                role="tab"
                data-target="residential"
                aria-selected="true"
                className="active tab-trigger"
              >
                Residential
              </button>
              <button
                role="tab"
                data-target="commercial"
                aria-selected="false"
                className="tab-trigger"
              >
                Commercial
              </button>
              <button
                role="tab"
                data-target="selective"
                aria-selected="false"
                className="tab-trigger"
              >
                Selective Interior
              </button>
              <button
                role="tab"
                data-target="full"
                aria-selected="false"
                className="tab-trigger"
              >
                Full Structure
              </button>
            </div>
            <div className="tabs-content">
              <div
                id="residential"
                role="tabpanel"
                className="active tab-panel"
              >
                <div className="tab-grid">
                  <div className="tab-info">
                    <h3>Home &amp; Garage Removal</h3>
                    <p className="section-content">
                      Safe removal of single-family homes, garages, and sheds
                      with minimal neighborhood disruption.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <span>Timeline: 2-5 Business Days</span>
                      </li>
                      <li>
                        <span>Permit coordination included</span>
                      </li>
                      <li>
                        <span>Full site cleanup and grading</span>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-image">
                    <img
                      alt="Residential Demolition"
                      src="https://images.pexels.com/photos/10451773/pexels-photo-10451773.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    />
                  </div>
                </div>
              </div>
              <div id="commercial" role="tabpanel" className="tab-panel">
                <div className="tab-grid">
                  <div className="tab-info">
                    <h3>Industrial &amp; Retail Clearing</h3>
                    <p className="section-content">
                      High-capacity demolition for warehouses, retail centers,
                      and office complexes.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <span>Timeline: Scale-dependent (Weeks/Months)</span>
                      </li>
                      <li>
                        <span>OSHA-compliant safety protocols</span>
                      </li>
                      <li>
                        <span>Asset recovery and salvage options</span>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-image">
                    <img
                      alt="Commercial Demolition"
                      src="https://images.pexels.com/photos/31024345/pexels-photo-31024345.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    />
                  </div>
                </div>
              </div>
              <div id="selective" role="tabpanel" className="tab-panel">
                <div className="tab-grid">
                  <div className="tab-info">
                    <h3>Precision Interior Gutting</h3>
                    <p className="section-content">
                      Controlled removal of interior walls, flooring, and MEP
                      systems while preserving the shell.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <span>Timeline: 3-10 Business Days</span>
                      </li>
                      <li>
                        <span>Dust and noise mitigation</span>
                      </li>
                      <li>
                        <span>Critical path scheduling</span>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-image">
                    <img
                      alt="Selective Interior Demolition"
                      src="https://images.pexels.com/photos/12175620/pexels-photo-12175620.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    />
                  </div>
                </div>
              </div>
              <div id="full" role="tabpanel" className="tab-panel">
                <div className="tab-grid">
                  <div className="tab-info">
                    <h3>Total Site Clearance</h3>
                    <p className="section-content">
                      Complete eradication of structures, foundations, and
                      underground utilities.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <span>Timeline: Comprehensive Project Plan</span>
                      </li>
                      <li>
                        <span>Environmental remediation support</span>
                      </li>
                      <li>
                        <span>Ready-to-build site delivery</span>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-image">
                    <img
                      alt="Full Structure Demolition"
                      src="https://images.pexels.com/photos/11518763/pexels-photo-11518763.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="disposal-pathways-section">
        <div className="services-section-container">
          <div className="services-section-header">
            <h2 className="services-section-title section-title">
              Disposal &amp; Logistics
            </h2>
            <p className="section-content">
              Efficient waste management solutions for every volume of debris.
            </p>
          </div>
          <div className="tabs-wrapper">
            <div role="tablist" className="tabs-nav">
              <button
                role="tab"
                data-target="dumpsters"
                aria-selected="true"
                className="active tab-trigger"
              >
                Roll-Off Dumpsters
              </button>
              <button
                role="tab"
                data-target="haul-away"
                aria-selected="false"
                className="tab-trigger"
              >
                Scheduled Haul-Away
              </button>
              <button
                role="tab"
                data-target="recycling"
                aria-selected="false"
                className="tab-trigger"
              >
                Recycling &amp; Landfill
              </button>
            </div>
            <div className="tabs-content">
              <div id="dumpsters" role="tabpanel" className="active tab-panel">
                <div className="disposal-grid">
                  <div className="disposal-card">
                    <div className="card-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                          <circle r="2" cx="17" cy="18"></circle>
                          <circle r="2" cx="7" cy="18"></circle>
                        </g>
                      </svg>
                    </div>
                    <h3>10-Yard Bin</h3>
                    <p>
                      Ideal for small renovations or heavy materials like
                      concrete/dirt.
                    </p>
                    <span className="weight-tag">Max: 2 Tons</span>
                  </div>
                  <div className="disposal-card">
                    <div className="card-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M13 4a1 1 0 0 1 1 1h4a1 1 0 0 1 .783.378l.074.108l3 5l.055.103l.04.107l.029.109l.016.11L22 11v6a1 1 0 0 1-1 1h-1.171a3.001 3.001 0 0 1-5.658 0H9.829a3.001 3.001 0 0 1-5.658 0H3a1 1 0 0 1-1-1V6a2 2 0 0 1 2-2zM7 16a1 1 0 1 0 0 2a1 1 0 0 0 0-2m10 0a1 1 0 1 0 0 2a1 1 0 0 0 0-2m.434-9H14v3h5.234z"
                          fill="currentColor"
                        ></path>
                      </svg>
                    </div>
                    <h3>20-Yard Bin</h3>
                    <p>
                      Standard for residential cleanouts and medium construction
                      jobs.
                    </p>
                    <span className="weight-tag">Max: 4 Tons</span>
                  </div>
                  <div className="disposal-card">
                    <div className="card-icon">
                      <svg
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15"></path>
                          <path d="M9 9a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3zM7 19a2 2 0 1 0 4 0a2 2 0 1 0-4 0m9 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0"></path>
                        </g>
                      </svg>
                    </div>
                    <h3>30-Yard Bin</h3>
                    <p>
                      Large volume for major demolition and commercial debris.
                    </p>
                    <span className="weight-tag">Max: 6 Tons</span>
                  </div>
                </div>
              </div>
              <div id="haul-away" role="tabpanel" className="tab-panel">
                <div className="haul-content">
                  <div className="haul-text">
                    <h3>On-Demand Junk Removal</h3>
                    <p className="section-content">
                      We do the heavy lifting. Our team arrives, loads, and
                      hauls away your debris instantly. Perfect for sites with
                      limited space for a permanent dumpster.
                    </p>
                    <div className="haul-stats">
                      <div className="h-stat">
                        <strong>2HR</strong>
                        <span>Arrival Window</span>
                      </div>
                      <div className="h-stat">
                        <strong>LBS</strong>
                        <span>Weight-Based Pricing</span>
                      </div>
                      <div className="h-stat">
                        <strong>24/7</strong>
                        <span>Emergency Service</span>
                      </div>
                    </div>
                  </div>
                  <img
                    alt="Haul Away Service"
                    src="https://images.pexels.com/photos/9090142/pexels-photo-9090142.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  />
                </div>
              </div>
              <div id="recycling" role="tabpanel" className="tab-panel">
                <div className="recycling-grid">
                  <div className="r-item">
                    <h4>90% Diversion Rate</h4>
                    <p>
                      We sort all debris to maximize recycling of concrete,
                      metal, and wood.
                    </p>
                  </div>
                  <div className="r-item">
                    <h4>Certified Facilities</h4>
                    <p>
                      Disposal at EPA-monitored transfer stations and landfills.
                    </p>
                  </div>
                  <div className="r-item">
                    <h4>Compliance Reporting</h4>
                    <p>
                      Detailed diversion reports for LEED projects and city
                      requirements.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="special-handling-section">
        <div className="bento-container">
          <div className="bento-grid">
            <div className="bento-cell bento-main">
              <div className="bento-content">
                <div className="bento-icon">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <circle r="2" cx="12" cy="11.9"></circle>
                      <path d="M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6m6.9-1.5l1.4.8m7-7.5c.9 2.5 0 5.2-2.2 6.7c2.4-1.2 5.2-.6 6.9 1.5m-6.9-1.5l-1.4.8m3 9.9c-2.6-.4-4.6-2.6-4.7-5.3c-.2 2.6-2.1 4.8-4.7 5.2m4.7-6.8v1.6m1.5-10.1q-1.5-.3-3 0m6.5 11c.7-.7 1.2-1.6 1.5-2.5m-13 0c.3.9.8 1.8 1.5 2.5"></path>
                    </g>
                  </svg>
                </div>
                <h2 className="services-section-title section-title">
                  Hazardous &amp; Regulated Materials
                </h2>
                <p className="section-content">
                  Panda Demolition is fully certified for the containment and
                  disposal of complex environmental hazards. We follow strict
                  EPA and OSHA guidelines to ensure site safety and legal
                  compliance.
                </p>
                <div className="bento-tags">
                  <span>Asbestos Abatement</span>
                  <span>Lead Paint Removal</span>
                  <span>Soil Remediation</span>
                </div>
              </div>
              <img
                alt="Hazardous Material Handling"
                src="https://images.pexels.com/photos/9090138/pexels-photo-9090138.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              />
            </div>
            <div className="bento-side bento-cell">
              <div className="bento-content">
                <h3>E-Waste Management</h3>
                <p className="section-content">
                  Secure disposal of servers, hardware, and electronic
                  components with data destruction certification.
                </p>
              </div>
            </div>
            <div className="bento-side bento-cell">
              <div className="bento-content">
                <h3>Containment Tech</h3>
                <p className="section-content">
                  Advanced HEPA filtration and negative pressure systems used
                  during sensitive interior abatements.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-process-section">
        <div className="process-wrapper">
          <div className="services-section-header">
            <h2 className="services-section-title section-title">
              Our Project Lifecycle
            </h2>
            <p className="section-content">
              A systematic approach to demolition ensuring safety and efficiency
              from start to finish.
            </p>
          </div>
          <div className="steps-container">
            <div className="services-step-item">
              <div className="services-step-number">
                <span>01</span>
              </div>
              <div className="step-content">
                <h3>Estimate &amp; RFQ</h3>
                <p>
                  Submit your project details online. Our experts provide a
                  detailed quote and timeline within 24 hours.
                </p>
              </div>
            </div>
            <div className="services-step-item">
              <div className="services-step-number">
                <span>02</span>
              </div>
              <div className="step-content">
                <h3>Permits &amp; Prep</h3>
                <p>
                  We handle all local utility disconnects and city permits,
                  followed by site fencing and safety staging.
                </p>
              </div>
            </div>
            <div className="services-step-item">
              <div className="services-step-number">
                <span>03</span>
              </div>
              <div className="step-content">
                <h3>Demo &amp; Disposal</h3>
                <p>
                  Execution of the demolition plan using precision machinery and
                  immediate debris sorting for recycling.
                </p>
              </div>
            </div>
            <div className="services-step-item">
              <div className="services-step-number">
                <span>04</span>
              </div>
              <div className="step-content">
                <h3>Post-Job Cleanup</h3>
                <p>
                  Final site grading and debris sweep. We leave the site ready
                  for your next phase of construction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stats-pricing-section">
        <div className="services-section-container">
          <div className="services-section-header">
            <h2 className="services-section-title section-title">
              Transparency &amp; Trust
            </h2>
            <p className="section-content">
              Clear pricing frameworks and our proven track record in the
              industry.
            </p>
          </div>
          <div className="table-container">
            <table className="pricing-table">
              <thead>
                <tr>
                  <th>
                    <span>Service Type</span>
                  </th>
                  <th>
                    <span>Base Pricing</span>
                  </th>
                  <th>
                    <span>Typical Timeline</span>
                  </th>
                  <th>
                    <span>Key Features</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span>Residential Demo</span>
                  </td>
                  <td>
                    <span>From $5,000</span>
                  </td>
                  <td>
                    <span>3-5 Days</span>
                  </td>
                  <td>
                    <span>Permits + Full Cleanup</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Commercial Gut</span>
                  </td>
                  <td>
                    <span>From $12/sq ft</span>
                  </td>
                  <td>
                    <span>7-14 Days</span>
                  </td>
                  <td>
                    <span>Dust Control + Night Ops</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>10-Yard Dumpster</span>
                  </td>
                  <td>
                    <span>$350 Flat Rate</span>
                  </td>
                  <td>
                    <span>7-Day Rental</span>
                  </td>
                  <td>
                    <span>Concrete/Heavy Loads</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>30-Yard Dumpster</span>
                  </td>
                  <td>
                    <span>$550 Flat Rate</span>
                  </td>
                  <td>
                    <span>7-Day Rental</span>
                  </td>
                  <td>
                    <span>Bulk Waste Disposal</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="services-stats-grid">
            <div className="stat-box">
              <span className="services-stat-value">2,500+</span>
              <span className="services-stat-label">Projects Completed</span>
            </div>
            <div className="stat-box">
              <span className="services-stat-value">150k</span>
              <span className="services-stat-label">Tons Diverted</span>
            </div>
            <div className="stat-box">
              <span className="services-stat-value">24hr</span>
              <span className="services-stat-label">Avg. Response Time</span>
            </div>
            <div className="stat-box">
              <span className="services-stat-value">100%</span>
              <span className="services-stat-label">Safety Record</span>
            </div>
          </div>
        </div>
      </section>
      <section className="case-studies-section">
        <div className="carousel-wrapper">
          <div className="services-section-header">
            <h2 className="services-section-title section-title">
              Proven Results
            </h2>
            <p className="section-content">
              Recent projects showcasing our ability to handle complex
              demolition challenges.
            </p>
          </div>
          <div className="services-carousel-container">
            <div className="services-carousel-track">
              <div className="case-card">
                <div className="case-image">
                  <img
                    alt="Warehouse Demo"
                    src="https://images.pexels.com/photos/15804049/pexels-photo-15804049.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  />
                  <span className="case-tag">Industrial</span>
                </div>
                <div className="case-info">
                  <h3>Metro Warehouse Clearing</h3>
                  <p>
                    Full structure demolition of a 50,000 sq ft facility in
                    under 15 days with 95% material recovery.
                  </p>
                  <div className="case-outcome">
                    <span>Outcome: Ready for New Retail Hub</span>
                  </div>
                </div>
              </div>
              <div className="case-card">
                <div className="case-image">
                  <img
                    alt="Residential Demo"
                    src="https://images.pexels.com/photos/4953234/pexels-photo-4953234.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  />
                  <span className="case-tag">Residential</span>
                </div>
                <div className="case-info">
                  <h3>Historic District Tear-Down</h3>
                  <p>
                    Surgical demolition of a damaged structure between two
                    active residences with zero neighbor complaints.
                  </p>
                  <div className="case-outcome">
                    <span>Outcome: Safe Site for Custom Build</span>
                  </div>
                </div>
              </div>
              <div className="case-card">
                <div className="case-image">
                  <img
                    alt="Interior Demo"
                    src="https://images.pexels.com/photos/14546541/pexels-photo-14546541.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  />
                  <span className="case-tag">Commercial</span>
                </div>
                <div className="case-info">
                  <h3>Downtown Office Gut</h3>
                  <p>
                    Selective interior removal of three floors during business
                    hours using specialized noise-reduction tech.
                  </p>
                  <div className="case-outcome">
                    <span>Outcome: LEED-Certified Renovation</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-controls">
              <button
                aria-label="Previous Project"
                className="carousel-btn prev"
              >
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m15 18l-6-6l6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
              <button aria-label="Next Project" className="carousel-btn next">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m9 18l6-6l-6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="final-cta-section">
        <div className="services-cta-split">
          <div className="cta-dark cta-col">
            <div className="cta-inner">
              <h2 className="services-section-title section-title">
                Rent a Dumpster
              </h2>
              <p className="section-content">
                Choose your size and schedule delivery in under 60 seconds.
                Perfect for DIYers and contractors alike.
              </p>
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
                <div className="btn-primary btn btn-xl">
                  <span>Book Online Instantly</span>
                </div>
              </button>
            </div>
          </div>
          <div className="cta-accent cta-col">
            <div className="cta-inner">
              <h2 className="services-section-title section-title">
                Large Scale RFQ
              </h2>
              <p className="section-content">
                Need a full structure removed? Submit your site plans for a
                comprehensive demolition and disposal bid.
              </p>
              <a href="/rfq-portal">
                <div className="btn btn-xl btn-on-accent">
                  <span>Request a Custom Bid</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="services-container2">
        <div className="services-container3">
          <Script
            html={`<style>
        @keyframes fadeIn {from {opacity: 0;
transform: translateY(10px);}
to {opacity: 1;
transform: translateY(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="services-container4">
        <div className="services-container5">
          <Script
            html={`<script defer data-name="panda-demo-scripts">
(function(){
  // Tab System Functionality
  const setupTabs = () => {
    const tabWrappers = document.querySelectorAll('.tabs-wrapper');
    
    tabWrappers.forEach(wrapper => {
      const triggers = wrapper.querySelectorAll('.tab-trigger');
      const panels = wrapper.querySelectorAll('.tab-panel');
      
      triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const target = trigger.getAttribute('data-target');
          
          // Update triggers
          triggers.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          trigger.classList.add('active');
          trigger.setAttribute('aria-selected', 'true');
          
          // Update panels
          panels.forEach(p => {
            p.classList.remove('active');
            if(p.id === target) {
              p.classList.add('active');
            }
          });
        });
      });
    });
  };

  // Carousel Functionality
  const setupCarousel = () => {
    const track = document.querySelector('.carousel-track');
    const nextBtn = document.querySelector('.carousel-btn.next');
    const prevBtn = document.querySelector('.carousel-btn.prev');
    
    if (!track || !nextBtn || !prevBtn) return;

    let currentTranslate = 0;
    const cardWidth = 400 + 32; // card width + gap
    
    nextBtn.addEventListener('click', () => {
      const maxScroll = track.scrollWidth - track.parentElement.clientWidth;
      if (Math.abs(currentTranslate) < maxScroll) {
        currentTranslate -= cardWidth;
        track.style.transform = \`translateX(\${currentTranslate}px)\`;
      }
    });

    prevBtn.addEventListener('click', () => {
      if (currentTranslate < 0) {
        currentTranslate += cardWidth;
        track.style.transform = \`translateX(\${currentTranslate}px)\`;
      }
    });
  };

  // Initialize
  setupTabs();
  setupCarousel();
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Services
